import styled from 'styled-components';

export const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;
